// extracted by mini-css-extract-plugin
module.exports = {"green":"StringComplexity_green__1mg0Q","component":"StringComplexity_component__3gtDf"};